import { render, staticRenderFns } from "./PhysicalStateForm.vue?vue&type=template&id=562c5130&scoped=true&"
import script from "./PhysicalStateForm.vue?vue&type=script&lang=js&"
export * from "./PhysicalStateForm.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/forms.css?vue&type=style&index=0&id=562c5130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562c5130",
  null
  
)

export default component.exports